<template>
  <div class="com-list-content carousel-wrapper">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="首页：" prop="picId">
            <div class="uploader-form" @click="uploadPicture(1)">
              <img v-if="form.pic1" :src="form.pic1" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="tip-img" style="left: 0">建议图片大小：375 * 215</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="讲解预约：" prop="picId">
            <div class="uploader-form" @click="uploadPicture(2)">
              <img class="img-wrapper" v-if="form.pic2" :src="form.pic2" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <!-- <div class="el-upload__text">上传轮播图封面</div> -->
            </div>
            <div class="tip-img" style="left: 0">建议图片大小：375 * 215</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="活动招募：" prop="picId">
            <div class="uploader-form" @click="uploadPicture(3)">
              <img v-if="form.pic3" :src="form.pic3" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <!-- <div class="el-upload__text">上传轮播图封面</div> -->
            </div>
            <div class="tip-img" style="left: 0">建议图片大小：375 * 215</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务预约：" prop="picId">
            <div class="uploader-form" @click="uploadPicture(4)">
              <img v-if="form.pic4" :src="form.pic4" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <!-- <div class="el-upload__text">上传轮播图封面</div> -->
            </div>
            <div class="tip-img" style="left: 0">建议图片大小：375 * 215</div>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div class="btn">
      <el-button type="primary" v-if="editFlag" :loading="loadingSave" @click="submit">确定</el-button>
      <el-button type="primary" v-else @click="editFlag = true">编辑</el-button>

    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </div>
</template>

<script>
import CropperImage from "@cmp/cropper";
export default {
  components: { CropperImage },
  data() {
    return {
      form: {
        pic1: '',
        pic2: '',
        pic3: '',
        pic4: '',
      },
      imgUrl: '',
      rules: {},
      editFlag: true,
      loadingSave: false,
      //裁切图片参数
      cropperModel: false,
      type: 1
    }
  },
  methods: {
    handleUploadSuccess(result) {
      switch (this.type) {
        case 1:
          this.form.pic1 = result.attPath
          break
        case 2:
          this.form.pic2 = result.attPath
          break
        case 3:
          this.form.pic3 = result.attPath
          break
        case 4:
          this.form.pic4 = result.attPath
          break
      }
      this.imgUrl = ""
      this.cropperModel = false
    },

    getData() {
      this.$api.applet.getPics({
        type: 1
      }).then(res => {
        if (res.success) {
          if (res.result) {
            this.form = res.result
            this.editFlag = false
          }
        }
      })
    },

    //封面设置
    uploadPicture(type) {
      if (!this.editFlag) {
        return
      }
      this.type = type
      this.imgUrl = this.form[`pic${type}`]

      let option = {
        cropWidth: "375", cropHeight: "215", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = 'addPics'
          if (this.form.id) {
            url = 'updatePics'
          }
          this.$api.applet[url]({
            ...this.form,
            type: 1
          }).then(res => {
            this.loadingSave = false

            if (res.success) {
              if (this.form.id) {
                this.$message.success('修改成功')
              } else {
                this.$message.success('新增成功')
              }
              this.getData()
            } else {
              this.$message.warning(res.message)
            }
          }).catch(err => {
            this.loadingSave = false
          })
        }
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.carousel-wrapper {
  height: 100%;
  margin-top: 0;
  .uploader-form {
    width: 400px;
    height: 250px;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px dashed #8c939d;
    i {
      font-size: 34px;
    }

    img{
      width: 375px;
      height: 215px;
      object-fit: cover;
    }
  }

  .btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}
</style>